import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

export const CARGO_ANALISTA_DE_MARKETING_PLANEJAMENTO: MapaCargo = 
{
  id: 'analista-de-marketing-planejamento',
  titulo: 'Analista de Marketing - Planejamento',
  setor: 'Marketing',
  secoes: [
    {
      id: 'desenvolver-planos-estrategicos-de-marketing',
      titulo: 'Desenvolver planos estratégicos de marketing',
      atividades: [
        'Criar planos de marketing integrados que alinhem os objetivos da empresa com as ações de marketing, considerando orçamento, recursos e KPIs.',
      ],
    },
    {
      id: 'analisar-dados-e-resultados',
      titulo: 'Analisar dados e resultados',
      atividades: [
        'Monitorar métricas de desempenho de campanhas (ROI, CPL, CAC, LTV, entre outras).',
        'Gerar insights a partir de dados para otimizar estratégias e ações futuras.',
      ],
    },
    {
      id: 'realizar-auditorias-de-marketing',
      titulo: 'Realizar auditorias de marketing',
      atividades: [
        'Avaliar o desempenho das campanhas atuais, canais de comunicação e materiais.',
        'Identificar pontos fortes, fraquezas e oportunidades de melhoria.',
      ],
    },
    {
      id: 'gerir-o-branding-da-empresa',
      titulo: 'Gerir o branding da empresa',
      atividades: [
        'Garantir a consistência e a relevância da identidade visual e do tom de voz nas ações de marketing.',
        'Desenvolver estratégias para fortalecer a marca no mercado.',
      ],
    },
    {
      id: 'definir-e-acompanhar-indicadores-de-performance-kpis',
      titulo: 'Definir e acompanhar indicadores de performance (KPIs)',
      atividades: [
        'Estabelecer metas claras para cada campanha e ação de marketing.',
        'Acompanhar regularmente os indicadores e sugerir ajustes.',
      ],
    },
    {
      id: 'relacionamento-com-stakeholders',
      titulo: 'Relacionamento com stakeholders',
      atividades: [
        'Interagir com equipes internas, fornecedores, agências parceiras e clientes para garantir alinhamento e execução de estratégias.',
      ],
    },
    {
      id: 'gestao-orcamentaria',
      titulo: 'Gestão orçamentária',
      atividades: [
        'Planejar, controlar e alocar o orçamento de marketing de forma eficiente.',
        'Identificar oportunidades para maximizar o uso dos recursos financeiros.',
      ],
    },
    {
      id: 'criacao-de-roadmaps-e-cronogramas',
      titulo: 'Criação de roadmaps e cronogramas',
      atividades: [
        'Desenvolver cronogramas detalhados para implementação de ações e campanhas.',
        'Coordenar entregas e prazos entre diferentes equipes.',
      ],
    },
    {
      id: 'identificacao-de-tendencias-e-oportunidades',
      titulo: 'Identificação de tendências e oportunidades',
      atividades: [
        'Realizar análise de tendências de mercado, comportamento do consumidor e inovações tecnológicas para incorporar nas estratégias.',
        'Sugerir novas ações com base em oportunidades identificadas.',
      ],
    },
    {
      id: 'consultoria',
      titulo: 'Consultoria',
      atividades: [
        'Promover um trabalho consultivo com o cliente, a fim de desenvolver estratégias e caminhos para otimizar resultados das contas.',
      ],
    },
    {
      id: 'automacao-e-integracao-de-ferramentas',
      titulo: 'Automação e integração de ferramentas',
      atividades: [
        'Configurar e integrar ferramentas de CRM, automação de marketing e análise de dados.',
        'Criar fluxos de automação alinhados ao funil de vendas.',
      ],
    },
    {
      id: 'gestao-de-crises',
      titulo: 'Gestão de crises',
      atividades: [
        'Desenvolver planos de contingência e ações para mitigar impactos em situações de crise que afetem a marca ou campanhas.',
      ],
    },
    {
      id: 'documentacao-e-relatorios',
      titulo: 'Documentação e relatórios',
      atividades: [
        'Criar relatórios detalhados de resultados, com análises e recomendações baseadas em dados.',
        'Documentar os processos de planejamento e execução de campanhas.',
      ],
    },
    {
      id: 'atendimento-ao-cliente',
      titulo: 'Atendimento ao cliente',
      atividades: [
        'Servir de ponto de contato entre clientes e a equipe da agência.',
        'Reunir feedbacks e acompanhar aprovações e revisões.',
        'Agendar reuniões para acompanhamento e/ou conforme necessidade.',
      ],
    },
  ],
}
